import axios from "axios";
import { SocialButtonProps } from "../../type";
import { ZaloSvg } from "../../icons";
import { useEffect } from "react";

export default function ZaloLoginButton({ apiEndpoint, onSuccess, onError }: SocialButtonProps) {

  useEffect(() => {
    const handleEvent = (e: any) => {
      if (e.data.code && e.data.state) {
        onSuccess(e.data, 'zalo')
      }
    }
    window.addEventListener("message", handleEvent);
    return () => {
      window.removeEventListener("message", handleEvent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <button type="button" className="zalo_btn" onClick={async () => {
    try {
      const { data } = (await axios.get(`${apiEndpoint}/auth/login/zalo/permissions`)).data;
      window.open(data.redirectUrl, "ZaloLogin", "width=600,height=600,scrollbars=yes");
    } catch (e: any) {
      onError(e?.response?.data || e);
    }
  }}>
    <ZaloSvg />
    <span>Zalo</span>
  </button>
}